<!--
 * @Author: Tang Hao
 * @Date: 2024-07-05 15:51:51
 * @LastEditors: Tang Hao
 * @LastEditTime: 2024-07-05 16:00:20
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
// import Form from './form';

export default {
  extends: TablePage,
  components: {
    // Form,
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('wechat_paymen_detail_list');
  },
  methods: {

  },
};
</script>
